import React from 'react'
import wordmark from 'assets/svg/wordmark-blue.svg'
import incBadge from 'assets/svg/inc5000-badge.svg'
import appleIcon from 'assets/img/apple-store.png'
import googleIcon from 'assets/img/google-play.png'
import { Instagram, Facebook } from 'react-feather'
import { format } from 'date-fns'
import styles from './Footer.module.css'
import env from 'env'
import LazyImage from 'app/theme/LazyImage'

// Same thin-line stroke style as the react-feather icons (24 viewBox, stroke 2,
// round caps/joins). X = Tabler `brand-x` (MIT), LinkedIn = Lucide `linkedin` (ISC).
const iconProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': 'true',
  focusable: 'false',
}

const XIcon = () => (
  <svg {...iconProps}>
    <path d="M4 4l11.733 16h4.267l-11.733 -16z" />
    <path d="M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772" />
  </svg>
)

const LinkedinIcon = () => (
  <svg {...iconProps}>
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
    <rect width="4" height="12" x="2" y="9" />
    <circle cx="4" cy="4" r="2" />
  </svg>
)

export default function Footer(props) {
  return (
    <footer className={[styles.Footer, 'font-light']}>
      <div className="container pt-10 pb-3">

        <div className="flex flex-wrap -mx-4">
          <ul className="w-1/2 md:w-1/4 px-4">
            <li><h4>Food Trucks</h4></li>
            <li><a href="/food-trucks/">Find Trucks</a></li>
            <li><a href="/food-truck-catering/">Catering</a></li>
            <li><a href="//vendor.roaminghunger.com/">Vendors</a></li>
            <li><a href="//mobilefoodalliance.com/">Buy/Lease a Truck</a></li>
            <li><a href="/experiential-marketing-agency/">Brand Activations</a></li>
          </ul>
          <ul className="w-1/2 md:w-1/4 px-4">
            <li><h4>Company</h4></li>
            <li><a href="/pages/about/">About</a></li>
            <li><a href="/blog/">Blog</a></li>
            <li><a href="/press/">Press</a></li>
          </ul>
          <div className="flex flex-wrap w-full md:w-1/4">
            <ul className="w-1/2 md:w-full px-4">
              <li><h4>Vendors</h4></li>
              <li><a href="//vendor.roaminghunger.com/">Why Work With Us?</a></li>
              <li><a href="//vendor.roaminghunger.com/login/">Vendor Login</a></li>
              <li><a href="//vendor.roaminghunger.com/get-started/">Add My Business</a></li>
            </ul>
            <ul className="w-1/2 md:w-full px-4">
              <li><h4>Questions?</h4></li>
              <li>
                <p>Call Us 24/7</p>
                <p>1-800-568-9370</p>
              </li>
              <li><a href="/catering/questions-and-answers/">Catering Frequently Asked Questions</a></li>
            </ul>
          </div>
          <div className="w-full md:w-1/4 text-center md:text-left">

            <div className={[styles.brandRow, 'flex items-center justify-center md:justify-start']}>
              <LazyImage
                className={styles.wordmark}
                src={wordmark}
                width="115"
                height="44"
                alt="Roaming Hunger"
              />
              <a
                className={styles.badgeLink}
                href="https://www.inc.com/profile/insperience-group"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Inc. 5000: Insperience Group profile (opens in a new tab)"
              >
                <LazyImage
                  className={styles.badge}
                  src={incBadge}
                  width="56"
                  height="56"
                  alt="Inc. 5000 — America's Fastest-Growing Private Companies, Insperience Group honoree"
                />
              </a>
            </div>
            <div className={[styles.social, 'flex items-center justify-center md:justify-start mb-3']}>
              <a href="https://x.com/roaminghunger" target="_blank" rel="noreferrer" aria-label="X">
                <XIcon />
              </a>
              <a href="https://www.instagram.com/roaminghunger/" target="_blank" rel="noreferrer" aria-label="Instagram">
                <Instagram aria-hidden="true" focusable="false" />
              </a>
              <a href="https://www.facebook.com/roaminghunger" target="_blank" rel="noreferrer" aria-label="Facebook">
                <Facebook aria-hidden="true" focusable="false" />
              </a>
              <a href="https://www.linkedin.com/company/roaming-hunger/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                <LinkedinIcon />
              </a>
            </div>
            <div className="text-xs">
              <a href="/sitemap.xml">Sitemap</a>
              <span className="px-1">|</span>
              <a target="_blank" rel="noreferrer" href="https://privacy.cptn.co/privacy-policy/6e1b0402-6e56-453c-9c37-de518dddb75d">Privacy Notice</a>
              <span className="px-1">|</span>
              <a target="_blank" rel="noreferrer" href="https://dsar.cptn.co/dsar/a0496922-ab92-4dd5-adef-d590490c1752">Data Subject Rights</a>
              <span className="px-1">|</span>
              <a href="/pages/terms_and_conditions/">Terms &amp; Conditions</a>
              <div>&copy; {format(new Date(), 'yyyy')} Roaming Hunger</div>
              <div>
                Version: {env.APP_VERSION || 'n/a'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
